import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";
import AuthBar from "./components/AuthBar";
import Home from "./pages/Home";
import TestPage from "./pages/TestPage";
import assignmentsJson from "./assignments.json";
import "./App.css";
import SignIn from "./pages/SignIn";
import BookmarksPage from "./pages/BookmarksPage";
import BookmarkGroupPage from "./pages/BookmarkGroupPage";
import AnalyticsPage from "./pages/AnalyticsPage";

export default function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => setUser(u));
    return () => unsub();
  }, []);

  return (
    <Router>
      <div className="min-h-screen bg-slate-50 text-gray-900">
        <div className="w-full mx-auto py-4">
          <div className="flex justify-between items-center pb-4 mb-2 mx-auto container border-b">
            <div className="flex gap-4">
              <Link to="/" className="text-2xl font-bold">
                QGRILLER
              </Link>

              <Link to="/bookmarks" className="text-xl text-blue-600 underline">
                Bookmarks
              </Link>
              <Link to="/analytics" className="text-xl text-blue-600 underline">
                Analytics
              </Link>
            </div>
            <AuthBar user={user} />
          </div>

          <Routes>
            <Route
              path="/"
              element={<Home user={user} assignmentsJson={assignmentsJson} />}
            />
            <Route
              path="/signin"
              element={<SignIn user={user} setUser={setUser} />}
            />
            <Route path="/analytics" element={<AnalyticsPage user={user} />} />
            <Route path="/bookmarks" element={<BookmarksPage user={user} />} />
            <Route
              path="/bookmarks/:groupId"
              element={<BookmarkGroupPage user={user} />}
            />
            <Route path="/:testId" element={<TestPage user={user} />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}
